import type { MetricsResponse } from "@shared/types";
import { TileCard } from "./TileCard";
import { Sparkline } from "./Sparkline";
import { formatInteger } from "@/lib/format";

interface LeadsTileProps {
  leads: MetricsResponse["leads"];
}

export function LeadsTile({ leads }: LeadsTileProps) {
  const { thisMonth, thisWeek, sparkline, byChannel } = leads;

  return (
    <TileCard label="Leads captured" testId="tile-leads">
      <div className="tile-number" data-testid="leads-month">
        {formatInteger(thisMonth)}
      </div>
      <div className="tile-subline" data-testid="leads-week">
        this week: {formatInteger(thisWeek)}
      </div>
      <Sparkline values={sparkline} ariaLabel="leads last 7 days" />
      <div className="channel-breakdown" data-testid="leads-channels">
        <span>
          WhatsApp <strong>{formatInteger(byChannel.whatsapp)}</strong>
        </span>
        <span>
          Voice <strong>{formatInteger(byChannel.voice)}</strong>
        </span>
        <span>
          Web <strong>{formatInteger(byChannel.web)}</strong>
        </span>
      </div>
    </TileCard>
  );
}
